/**
 * HTTP layer for warehouse contacts. Single-contact CRUD against
 * `/warehouse/contacts`.
 *
 * Contains:
 * - fetchContacts / fetchContact: list and detail reads
 * - postContact / patchContact / deleteContact: contact writes
 */
import apiClient from '@sophocles/http-common';

const CONTACT_ENDPOINT = '/warehouse/contacts';

export const fetchContacts = queryParams =>
  apiClient.get(`${CONTACT_ENDPOINT}/`, { params: queryParams }).then(res => res.data);

export const fetchContact = contactId => apiClient.get(`${CONTACT_ENDPOINT}/${contactId}/`).then(res => res.data);

export const postContact = data => apiClient.post(`${CONTACT_ENDPOINT}/`, data).then(res => res.data);

export const patchContact = (contactId, data) =>
  apiClient.patch(`${CONTACT_ENDPOINT}/${contactId}/`, data).then(res => res.data);

export const deleteContact = contactId => apiClient.delete(`${CONTACT_ENDPOINT}/${contactId}/`);
